// QR Kiosk v2 — KV2-2 report helpers (pure functions + tokenized maps; NO React).
// URGENCY_META (PG-7 / D9), formatMoney (bug #2 — symbol from Money.id),
// findPartTranslationKey (v1 camelCase join, verbatim), date format + image test.
import { Money, CurrencyCode } from "../../../common/models/CommonModels";
import { MachinePartGroup } from "../../models/serviceReportsModels";
import { PipTone } from "../shared/StatusPip";

export const REPORT_DATE_FORMAT = "DD.MM.YYYY, HH:mm"; // v1 verbatim, not locale-aware

/** PG-7 / D9: urgency 1/2/4 only — value 3 (map hole) + null render NOTHING. Tones per KV2-0 §5.4 hex map (v1 #C0392B/#E67E22/#27AE60). */
export const URGENCY_META: Record<number, { labelKey: string; tone: PipTone }> = {
  1: { labelKey: "urgencyUrgent", tone: "--red" },
  2: { labelKey: "urgencyHigh", tone: "--amber" },
  4: { labelKey: "urgencyLow", tone: "--green" },
};

const NBSP = " "; // non-breaking space — thousands sep + amount/symbol gap stay unwrappable

/** Bug #2: symbol from Money.id — NEVER a hardcoded EUR suffix. Unmapped id -> value only, no symbol (never guess). */
const CURRENCY_SYMBOL: Partial<Record<CurrencyCode, string>> = {
  [CurrencyCode.eur]: "€",
  [CurrencyCode.usd]: "$",
};

export function formatMoney(money?: Money | null): string | null {
  if (!money || typeof money.value !== "number" || isNaN(money.value)) return null;
  const [int, dec] = Math.abs(money.value).toFixed(2).split(".");
  const grouped = int.replace(/\B(?=(\d{3})+(?!\d))/g, NBSP); // NBSP thousands (ticket §2.6 ' ' sep, non-breaking)
  const sign = money.value < 0 ? "-" : "";
  const sym = CURRENCY_SYMBOL[money.id];
  return sym ? `${sign}${grouped},${dec}${NBSP}${sym}` : `${sign}${grouped},${dec}`;
}

/** v1 ServiceReportPage partName join, verbatim: find part by id across groups, camelCase its code. Returns the servicing-namespace key suffix. */
export function findPartTranslationKey(machineParts: MachinePartGroup[], affectedPartCategoryId?: string): string | undefined {
  if (!affectedPartCategoryId || !machineParts?.length) return undefined;
  for (const group of machineParts) {
    const found = group.parts.find((p) => p.id === affectedPartCategoryId);
    if (found) return found.code.replace(/_([a-z])/g, (_m, c: string) => c.toUpperCase());
  }
  return undefined;
}

export function isImageFileName(name?: string): boolean {
  return !!name && /\.(png|jpe?g|gif|webp|bmp)$/i.test(name);
}
